module.exports = __webpack_public_path__ + "media/workplace/playlist-icon-28751f74.png";